import { render, staticRenderFns } from "./custom_menu.vue?vue&type=template&id=085c7113&scoped=true"
import script from "./custom_menu.vue?vue&type=script&lang=js"
export * from "./custom_menu.vue?vue&type=script&lang=js"
import style0 from "./custom_menu.vue?vue&type=style&index=0&id=085c7113&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c7113",
  null
  
)

export default component.exports